// extracted by mini-css-extract-plugin
export default {"all":"Character-list_all__wQCr+"};